var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "77px",
    viewBox: "0 0 93 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 33 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emails",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Formats",
    transform: "translate(-259.000000, -139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(82.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33-Copy",
    transform: "translate(178.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7678685,38.5 C84.7678685,17.2374125 67.5898481,-4.61852778e-14 46.4005216,-4.61852778e-14 C25.2102359,-4.61852778e-14 8.03317463,17.2374125 8.03317463,38.5 C8.03317463,44.1643125 9.26188892,49.53795 11.4507461,54.38125 L81.3493379,54.38125 C83.538195,49.53795 84.7678685,44.1643125 84.7678685,38.5",
    id: "Fill-1",
    fill: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4512257,54.38125 C17.479695,67.71765 30.8555114,77 46.400042,77 C61.9455318,77 75.3203889,67.71765 81.3488583,54.38125 L11.4512257,54.38125 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99197463,54.38125 L83.8083012,54.38125",
    id: "Stroke-5",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6756481,54.38125 L7.07360728,54.38125",
    id: "Stroke-7",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7270522,54.38125 L88.1250114,54.38125",
    id: "Stroke-9",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7306746,68.83569 C61.7306746,69.673065 54.9665114,70.3516275 46.6235318,70.3516275 C38.279593,70.3516275 31.5163889,69.673065 31.5163889,68.83569 C31.5163889,67.998315 38.279593,67.3197525 46.6235318,67.3197525 C54.9665114,67.3197525 61.7306746,67.998315 61.7306746,68.83569",
    id: "Fill-11",
    fill: "#020202",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3557175,55.495055 L65.3518808,36.091055 C65.3518808,34.7522175 64.2699216,33.665555 62.9347379,33.665555 L30.3071461,33.665555 C28.9729216,33.665555 27.8909624,34.7522175 27.8909624,36.091055 L27.8947991,55.495055 L65.3557175,55.495055 Z",
    id: "Fill-13",
    fill: "#00B8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7251522,55.495055 L54.4784787,33.665555 L30.3070501,33.665555 C28.9728257,33.665555 27.8908665,34.7522175 27.8908665,36.091055 L27.8947032,55.495055 L32.7251522,55.495055 Z",
    id: "Fill-15",
    fill: "#4ACFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3519767,55.495055 L65.3519767,60.346055 C65.3519767,61.685855 64.2700175,62.7725175 62.9338746,62.7725175 L30.307242,62.7725175 C28.9730175,62.7725175 27.8910583,61.685855 27.8910583,60.346055 L27.8910583,55.495055 L65.3519767,55.495055 Z",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3519767,55.495055 L65.3519767,60.346055 C65.3519767,61.685855 64.2700175,62.7725175 62.9338746,62.7725175 L30.307242,62.7725175 C28.9730175,62.7725175 27.8910583,61.685855 27.8910583,60.346055 L27.8910583,55.495055 L65.3519767,55.495055 Z",
    id: "Stroke-19",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8318154,59.1331125 C47.8318154,59.8030125 47.291795,60.3458625 46.623244,60.3458625 C45.9556522,60.3458625 45.4146726,59.8030125 45.4146726,59.1331125 C45.4146726,58.464175 45.9556522,57.9203625 46.623244,57.9203625 C47.291795,57.9203625 47.8318154,58.464175 47.8318154,59.1331125",
    id: "Fill-21",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8318154,59.1331125 C47.8318154,59.8030125 47.291795,60.3458625 46.623244,60.3458625 C45.9556522,60.3458625 45.4146726,59.8030125 45.4146726,59.1331125 C45.4146726,58.464175 45.9556522,57.9203625 46.623244,57.9203625 C47.291795,57.9203625 47.8318154,58.464175 47.8318154,59.1331125 Z",
    id: "Stroke-23",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#DAEDF7",
    points: "52.6661971 67.6226513 40.5804828 67.6226513 41.1847685 62.7716513 52.0619114 62.7716513"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-27",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "52.6661971 67.6226513 40.5804828 67.6226513 41.1847685 62.7716513 52.0619114 62.7716513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.955344,67.6226513 L56.2915277,67.6226513",
    id: "Stroke-29",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3557175,55.495055 L65.3518808,36.091055 C65.3518808,34.7522175 64.2699216,33.665555 62.9347379,33.665555 L30.3071461,33.665555 C28.9729216,33.665555 27.8909624,34.7522175 27.8909624,36.091055 L27.8947991,55.495055 L65.3557175,55.495055 Z",
    id: "Stroke-31",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8754399,44.5804975 C53.8754399,48.5998975 50.627644,51.8569975 46.6230522,51.8569975 C42.6184603,51.8569975 39.3716236,48.5998975 39.3716236,44.5804975 C39.3716236,40.56206 42.6184603,37.3039975 46.6230522,37.3039975 C50.627644,37.3039975 53.8754399,40.56206 53.8754399,44.5804975",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0115603,38.1493612 C48.9996216,37.6113237 47.847642,37.3042862 46.6237236,37.3042862 C42.6181726,37.3042862 39.3713359,40.5613862 39.3713359,44.5807862 C39.3713359,45.8089362 39.6792338,46.9648987 40.2134991,47.9803362 L50.0115603,38.1493612 Z",
    id: "Fill-35",
    fill: "#F0FFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8754399,44.5804975 C53.8754399,48.5998975 50.627644,51.8569975 46.6230522,51.8569975 C42.6184603,51.8569975 39.3716236,48.5998975 39.3716236,44.5804975 C39.3716236,40.56206 42.6184603,37.3039975 46.6230522,37.3039975 C50.627644,37.3039975 53.8754399,40.56206 53.8754399,44.5804975 Z",
    id: "Stroke-37",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4146726,48.8252187 C44.9513869,48.8252187 44.487142,48.6481187 44.1332032,48.2929562 L41.7160603,45.8664937 C41.0072236,45.1561687 41.0072236,44.0050187 41.7160603,43.2946937 C42.4239379,42.5843687 43.5711216,42.5843687 44.2789991,43.2946937 L45.4146726,44.4342937 L48.3632032,41.4755687 C49.0710808,40.7642812 50.2182644,40.7642812 50.9271012,41.4755687 C51.6349787,42.1868562 51.6349787,43.3370437 50.9271012,44.0483312 L46.696142,48.2929562 C46.3422032,48.6481187 45.8789175,48.8252187 45.4146726,48.8252187",
    id: "Fill-39",
    fill: "#6DD627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0182032,46.1694887 L44.581142,43.5976887 L44.2789991,43.2945012 C43.5711216,42.5841762 42.4239379,42.5841762 41.7160603,43.2945012 C41.0072236,44.0048262 41.0072236,45.1559762 41.7160603,45.8672637 L42.0182032,46.1694887 Z",
    id: "Fill-41",
    fill: "#9CEB60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4146726,48.8252187 C44.9513869,48.8252187 44.487142,48.6481187 44.1332032,48.2929562 L41.7160603,45.8664937 C41.0072236,45.1561687 41.0072236,44.0050187 41.7160603,43.2946937 C42.4239379,42.5843687 43.5711216,42.5843687 44.2789991,43.2946937 L45.4146726,44.4342937 L48.3632032,41.4755687 C49.0710808,40.7642812 50.2182644,40.7642812 50.9271012,41.4755687 C51.6349787,42.1868562 51.6349787,43.3370437 50.9271012,44.0483312 L46.696142,48.2929562 C46.3422032,48.6481187 45.8789175,48.8252187 45.4146726,48.8252187 Z",
    id: "Stroke-43",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(0.000000, 15.104886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6998481,12.7925989 C26.8513991,13.3296739 26.5406236,13.8879239 26.0053991,14.0399989 L4.68850116,20.1047114 C4.15327667,20.2567864 3.59695014,19.9449364 3.44539912,19.4078614 L0.0383787133,7.35062391 C-0.113172307,6.81354891 0.197603203,6.25529891 0.732827693,6.10322391 L22.0497257,0.0385114057 C22.5849501,-0.113563594 23.1412767,0.198286406 23.2928277,0.735361406 L26.6998481,12.7925989 Z",
    id: "Fill-45",
    fill: "#6DD627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3374746,4.43039891 L1.08110728,11.0456614 L0.0384746317,7.35062391 C-0.113076389,6.81354891 0.197699121,6.25529891 0.732923611,6.10322391 L22.0498216,0.0385114057 C22.5850461,-0.113563594 23.1413726,0.198286406 23.2929236,0.735361406 L24.3374746,4.43039891 Z",
    id: "Fill-47",
    fill: "#9CEB60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.330044,9.75889516 L22.0111665,5.09173266 C20.7268195,5.45748266 19.3916359,4.70865766 19.0261869,3.41987016 L5.07390116,7.38922016 C5.43743177,8.67800766 4.69118688,10.0197327 3.40779912,10.3845202 L4.72571749,15.0516827 C6.01006443,14.6859327 7.34620728,15.4347577 7.71069708,16.7235452 L21.663942,12.7541952 C21.2994522,11.4654077 22.0456971,10.1246452 23.330044,9.75889516",
    id: "Fill-49",
    fill: "#C8FFA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0263787,3.41996641 L5.074093,7.38931641 C5.43762361,8.67810391 4.69137871,10.0188664 3.40799096,10.3846164 L22.0113583,5.09182891 C20.7270114,5.45757891 19.3908685,4.70875391 19.0263787,3.41996641",
    id: "Fill-51",
    fill: "#E4FFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6940787,9.41018141 C16.0576093,10.6989689 15.3123236,12.0397314 14.0279767,12.4054814 C12.7436297,12.7712314 11.4074869,12.0214439 11.0429971,10.7336189 C10.6785073,9.44483141 11.4257114,8.10406891 12.7090991,7.73831891 C13.9934461,7.37256891 15.3305481,8.12139391 15.6940787,9.41018141",
    id: "Fill-53",
    fill: "#9CEB60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6940787,9.41018141 C16.0576093,10.6989689 15.3123236,12.0397314 14.0279767,12.4054814 C12.7436297,12.7712314 11.4074869,12.0214439 11.0429971,10.7336189 C10.6785073,9.44483141 11.4257114,8.10406891 12.7090991,7.73831891 C13.9934461,7.37256891 15.3305481,8.12139391 15.6940787,9.41018141 Z",
    id: "Stroke-55",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.330044,9.75889516 L22.0111665,5.09173266 C20.7268195,5.45748266 19.3916359,4.70865766 19.0261869,3.41987016 L5.07390116,7.38922016 C5.43743177,8.67800766 4.69118688,10.0197327 3.40779912,10.3845202 L4.72571749,15.0516827 C6.01006443,14.6859327 7.34620728,15.4347577 7.71069708,16.7235452 L21.663942,12.7541952 C21.2994522,11.4654077 22.0456971,10.1246452 23.330044,9.75889516 Z",
    id: "Stroke-57",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6998481,12.7925989 C26.8513991,13.3296739 26.5406236,13.8879239 26.0053991,14.0399989 L4.68850116,20.1047114 C4.15327667,20.2567864 3.59695014,19.9449364 3.44539912,19.4078614 L0.0383787133,7.35062391 C-0.113172307,6.81354891 0.197603203,6.25529891 0.732827693,6.10322391 L22.0497257,0.0385114057 C22.5849501,-0.113563594 23.1412767,0.198286406 23.2928277,0.735361406 L26.6998481,12.7925989 Z",
    id: "Stroke-59",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(38.566389, 7.741291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1137102,8.085 C16.1137102,12.5500375 12.5062204,16.17 8.05752653,16.17 C3.60691429,16.17 0.00038367347,12.5500375 0.00038367347,8.085 C0.00038367347,3.6199625 3.60691429,3.19744231e-14 8.05752653,3.19744231e-14 C12.5062204,3.19744231e-14 16.1137102,3.6199625 16.1137102,8.085",
    id: "Fill-75",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05714286,9.62499999e-05 C3.6074898,9.62499999e-05 2.04281037e-13,3.62005875 2.04281037e-13,8.08509625 C2.04281037e-13,10.3171337 0.901632653,12.3393462 2.35959184,13.8013837 L13.7537347,2.36784625 C12.2967347,0.90484625 10.2814898,9.62499999e-05 8.05714286,9.62499999e-05",
    id: "Fill-77",
    fill: "#FFF48C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1137102,8.085 C16.1137102,12.5500375 12.5062204,16.17 8.05752653,16.17 C3.60691429,16.17 0.00038367347,12.5500375 0.00038367347,8.085 C0.00038367347,3.6199625 3.60691429,3.19744231e-14 8.05752653,3.19744231e-14 C12.5062204,3.19744231e-14 16.1137102,3.6199625 16.1137102,8.085 Z",
    id: "Stroke-79",
    stroke: "#45413C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05714286,12.1276925 L8.05714286,13.1383175",
    id: "Stroke-81",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05714286,3.031875 L8.05714286,4.0425",
    id: "Stroke-83",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04276122,10.1063462 C6.04276122,11.2228462 6.94439388,12.1275962 8.05704694,12.1275962 C9.1697,12.1275962 10.0713327,11.2228462 10.0713327,10.1063462 C10.0713327,8.98984625 9.1697,8.08509625 8.05704694,8.08509625 C6.94439388,8.08509625 6.04276122,7.18034625 6.04276122,6.06384625 C6.04276122,4.94734625 6.94439388,4.04259625 8.05704694,4.04259625 C9.1697,4.04259625 10.0713327,4.94734625 10.0713327,6.06384625",
    id: "Stroke-85",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy",
    transform: "translate(69.522338, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,29.1885656 C21,29.6365851 20.6572566,30 20.2339745,30 L0.766025549,30 C0.342743447,30 0,29.6365851 0,29.1885656 L0,0.811434431 C0,0.362774003 0.342743447,0 0.766025549,0 L16.8525621,0 C17.0554226,0 17.2504109,0.0858864248 17.3939272,0.237790027 L20.7753395,3.81681836 C20.9194613,3.96872196 21,4.17510576 21,4.39046276 L21,29.1885656 Z",
    id: "Fill-13",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3 C0,2.58565501 0.352110486,2.24955542 0.786960714,2.24955542 L20,2.24955542 L17.8699182,0.220509781 C17.7218576,0.0794309425 17.5221624,0 17.3131357,0 L0.786960714,0 C0.352110486,0 0,0.336099585 0,0.750444576 L0,3 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,29.1885656 C21,29.6365851 20.6572566,30 20.2339745,30 L0.766025549,30 C0.342743447,30 0,29.6365851 0,29.1885656 L0,0.811434431 C0,0.362774003 0.342743447,0 0.766025549,0 L16.8525621,0 C17.0554226,0 17.2504109,0.0858864248 17.3939272,0.237790027 L20.7753395,3.81681836 C20.9194613,3.96872196 21,4.17510576 21,4.39046276 L21,29.1885656 Z",
    id: "Stroke-17",
    stroke: "#45413C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(5.000000, 7.000000)",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41469125e-14,2.33176714 L11.9685195,2.33176714",
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09229221,-8.89288643e-14 L6.2213961,-8.89288643e-14",
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41469125e-14,4.66292 L11.9685195,4.66292",
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41469125e-14,6.99407286 L11.9685195,6.99407286",
    id: "Stroke-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy",
    transform: "translate(4.000000, 17.000000)",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,3.33176714 L12.9685195,3.33176714",
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L10.7216797,1",
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,5.66292 L12.9685195,5.66292",
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,7.99407286 L12.9685195,7.99407286",
    id: "Stroke-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.23705556e-14,3.10337143 C-9.23705556e-14,3.49405714 0.314350649,3.8098 0.701948052,3.8098 L3.78563636,3.8098 C3.74779221,3.72748571 3.70018182,3.64824286 3.63487013,3.58251429 L0.226454545,0.152342857 C0.161142857,0.0872285714 0.0824025974,0.0387 -9.23705556e-14,1.03028697e-13 L-9.23705556e-14,3.10337143 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.23705556e-14,3.10337143 C-9.23705556e-14,3.49405714 0.314350649,3.8098 0.701948052,3.8098 L3.78563636,3.8098 C3.74779221,3.72748571 3.70018182,3.64824286 3.63487013,3.58251429 L0.226454545,0.152342857 C0.161142857,0.0872285714 0.0824025974,0.0387 -9.23705556e-14,1.03028697e-13 L-9.23705556e-14,3.10337143 Z",
    id: "Stroke-33",
    stroke: "#45413C",
    strokeLinejoin: "round"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.882523ba1167fb03e846f43fc4777c1b.svg";
export { ForwardRef as ReactComponent };